import React from "react";
import { Link } from "react-router-dom";
import { Grid, Menu } from "antd";
import { connect, useDispatch } from "react-redux";
import { SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import utils from "utils";
// import { onMobileNavToggle } from "redux/actions/Theme";
import { usePermissions } from "../../data/hooks/usePermissions";
import { onMobileNavToggle } from "../../redux/actions/Theme";
import styled from "styled-components";
import Icon, { ExclamationCircleFilled, LogoutOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { useAuth } from "../../data/hooks/useAuth";
import { useTranslation } from "react-i18next";
import navigationConfig from "configs/NavigationConfig";
import { useTheme } from "../../data/hooks/theme/useTheme";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const { routeInfo, hideGroupTitle } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { uid: userId, email: authEmail, signOut } = useAuth();
  const { can } = usePermissions();
  const { sideNavTheme, navCollapsed, toggleMobileNav } = useTheme();
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      dispatch(onMobileNavToggle(false));
    }
  };
  // Een item zonder `permission` is voor iedereen; anders beslist het
  // permissiemodel (functions/permissions.js). Rolnamen komen hier niet voor.
  const hasAccess = (menu) => !menu.permission || can(menu.permission);

  // return (
  //   <Menu
  //     theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
  //     mode="inline"
  //     style={{ height: "100%", borderRight: 0 }}
  //     defaultSelectedKeys={[routeInfo?.key]}
  //     defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
  //     className={hideGroupTitle ? "hide-group-title" : ""}
  //   >
  //     {navigationConfig.map(
  //       (menu) =>
  //         hasAccess(menu) &&
  //         (menu.submenu.length > 0 ? (
  //           <Menu.ItemGroup key={menu.key} title={menu.title}>
  //             {menu.submenu.map((subMenuFirst) =>
  //               subMenuFirst.submenu.length > 0 ? (
  //                 <SubMenu
  //                   icon={subMenuFirst.icon ? <Icon type={subMenuFirst?.icon} /> : null}
  //                   key={subMenuFirst.key}
  //                   title={subMenuFirst.title}
  //                 >
  //                   {subMenuFirst.submenu.map((subMenuSecond) => (
  //                     <Menu.Item key={subMenuSecond.key}>
  //                       {subMenuSecond.icon ? <Icon type={subMenuSecond?.icon} /> : null}
  //                       <span>{subMenuSecond.title}</span>
  //                       <Link onClick={() => closeMobileNav()} to={subMenuSecond.path} />
  //                     </Menu.Item>
  //                   ))}
  //                 </SubMenu>
  //               ) : (
  //                 <Menu.Item key={subMenuFirst.key}>
  //                   {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
  //                   <span>{subMenuFirst.title}</span>
  //                   <Link onClick={() => closeMobileNav()} to={subMenuFirst.path} />
  //                 </Menu.Item>
  //               ),
  //             )}
  //           </Menu.ItemGroup>
  //         ) : (
  //           <Menu.Item key={menu.key}>
  //             {menu.icon ? <Icon type={menu?.icon} /> : null}
  //             <span>{menu?.title}</span>
  //             {menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
  //           </Menu.Item>
  //         )),
  //     )}
  //   </Menu>
  // );

  return (
    <div
      style={{
        height: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
          overflowX: "hidden",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Menu
          theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
          mode="inline"
          style={{ borderRight: 0 }}
          defaultSelectedKeys={[routeInfo?.key]}
          defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
          className={hideGroupTitle ? "hide-group-title" : ""}
          items={navigationConfig.filter(hasAccess).map((menu) => {
            if (menu.submenu.length > 0) {
              // Group with submenu items
              const children = menu.submenu
                .filter((subMenuFirst) => hasAccess(subMenuFirst))
                .filter((subMenuFirst) => !subMenuFirst.hidden)
                .map((subMenuFirst) => {
                  if (subMenuFirst.submenu.length > 0) {
                    // Nested submenu
                    const nested = subMenuFirst.submenu
                      .filter((subMenuSecond) => hasAccess(subMenuSecond))
                      .filter((subMenuSecond) => !subMenuSecond.hidden);
                    if (nested.length === 0) return null;
                    return {
                      key: subMenuFirst.key,
                      icon: subMenuFirst.icon ? <Icon type={subMenuFirst?.icon} /> : null,
                      label: t(subMenuFirst.title),
                      children: nested.map((subMenuSecond) => ({
                          key: subMenuSecond.key,
                          icon: subMenuSecond.icon ? <Icon type={subMenuSecond?.icon} /> : null,
                          label: (
                            <Link onClick={() => closeMobileNav()} to={subMenuSecond.path}>
                              {t(subMenuSecond.title)}
                            </Link>
                          ),
                        })),
                    };
                  } else {
                    // Single menu item
                    return {
                      key: subMenuFirst.key,
                      icon: subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null,
                      label: (
                        <Link onClick={() => closeMobileNav()} to={subMenuFirst.path}>
                          {t(subMenuFirst.title)}
                        </Link>
                      ),
                    };
                  }
                })
                .filter(Boolean);

              // Groep zonder zichtbare items (bijv. "Inkoop" voor een verkoper) weglaten.
              if (children.length === 0) return null;

              return {
                key: menu.key,
                label: t(menu.title),
                type: "group",
                children: children,
              };
            } else {
              // Single menu item without submenu
              return {
                key: menu.key,
                icon: menu.icon ? <Icon type={menu?.icon} /> : null,
                label: menu.path ? (
                  <Link onClick={() => closeMobileNav()} to={menu.path}>
                    {t(menu?.title)}
                  </Link>
                ) : (
                  t(menu?.title)
                ),
              };
            }
          }).filter(Boolean)}
        />
      </div>
      {/* Bottom section with user controls - only show when not collapsed */}
      {!navCollapsed && (
        <LowerMenu
          style={{
            borderTop: sideNavTheme === SIDE_NAV_LIGHT ? "1px solid #f0f0f0" : "1px solid #303030",
            backgroundColor: sideNavTheme === SIDE_NAV_LIGHT ? "#f9f9f9" : "#001529",
            marginBottom: 0,
          }}
        >
          {/* Language selector */}
          {/*<div style={{ marginBottom: "12px" }}>*/}
          {/*  <Radio.Group*/}
          {/*    options={[*/}
          {/*      { label: "English", value: "en" },*/}
          {/*      { label: "Nederlands", value: "nl" },*/}
          {/*    ]}*/}
          {/*    onChange={(e) => {*/}
          {/*      console.log(e);*/}
          {/*      changeLanguage(e.target.value);*/}
          {/*    }}*/}
          {/*    value={i18n.language}*/}
          {/*    optionType="button"*/}
          {/*    buttonStyle="solid"*/}
          {/*    size="small"*/}
          {/*  />*/}
          {/*</div>*/}

          <LowerMenuItem style={{ cursor: "default" }}>
            <UserOutlined /> <span style={{ marginLeft: "3px" }}>{authEmail}</span>
          </LowerMenuItem>

          {/*<LowerMenuItem>*/}
          {/*  <Link to={urls.profile} style={{ color: "inherit", textDecoration: "none" }}>*/}
          {/*    <SettingOutlined /> <span style={{ marginLeft: "3px" }}>{t("profile_settings")}</span>*/}
          {/*  </Link>*/}
          {/*</LowerMenuItem>*/}

          <LowerMenuItem
            onClick={(e) => {
              e.preventDefault();
              signOut();
            }}
          >
            <LogoutOutlined /> <span style={{ marginLeft: "3px" }}>{t("logout")}</span>
          </LowerMenuItem>
        </LowerMenu>
      )}
    </div>
  );
};

const LowerMenu = styled.ul`
  flex-shrink: 0;
  padding: 16px;
  list-style: none;
`;

const LowerMenuItem = styled.li`
  margin-bottom: 12px;
  transition: color 0.2s ease;

  &:not(:first-child):hover {
    cursor: pointer;
    color: rgb(62, 121, 247);
  }
`;

const MenuContent = (props) => {
  return <SideNavContent {...props} />;
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, null)(MenuContent);
